const userAgent = navigator.userAgent

// 平台是否是android
// export const isAndroid =
//   userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1 // android终端
// 平台是否是iOS
// export const isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端

// 是否是App
export const isApp = !!userAgent.toLocaleLowerCase().match(/native_/)
// 平台是否是android
export const isAndroid = !!userAgent.toLocaleLowerCase().match(/native_andriod/)
// 平台是否是iOS
export const isiOS = !!userAgent.toLocaleLowerCase().match(/native_ios/)
